<template>
  <v-dialog v-model="dialogModel" persistent max-width="500">
    <v-form ref="noteDialog" @submit.prevent="park">
      <v-card>
        <v-card-title>
          <h3>Park Current Sale</h3>
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Note"
            v-model="saleNote"
            :rules="[(v) => !!v || 'Required']"
          >
          </v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click.native="closeDialogModal">
            Cancel
            <v-icon right>clear</v-icon>
          </v-btn>
          <v-btn color="blue darken-1" flat type="submit">
            Save
            <v-icon right>save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "sale"],
  data: () => ({
    saleNote: "",
  }),
  computed: {
    dialogModel: {
      get() {
        return this.dialog;
      },
      set() {
        this.$emit("update:dialog");
      },
    },
  },
  methods: {
    park() {
      if (!this.$refs.noteDialog.validate()) return;

      let parkItems = JSON.parse(localStorage.getItem("parkItems"));
      if (!parkItems) parkItems = [];

      parkItems.push({ ...this.sale, note: this.saleNote });
      localStorage.setItem("parkItems", JSON.stringify(parkItems));

      this.$emit("parked");

      this.closeDialogModal();
    },
    closeDialogModal() {
      this.saleNote = "";
      this.$refs.noteDialog.resetValidation();
      this.dialogModel = false;
    },
  },
};
</script>

<style></style>
